import React from 'react';
import './FaceList.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash } from '@fortawesome/free-solid-svg-icons';
import { checkUrl } from 'Flow2/components/Ai/Faces/FaceHelper/FaceHelper';

export default function FaceList({ faces, fallbackText, onSelectFace, onDeleteFace }) {
    return (
        <section className="facelist-section">
            {faces.length === 0 && <p className="fallback-text">{fallbackText}</p>}
            {faces.length > 0 && (
                <ul className="facelist-items">
                    {faces.map((face) => {
                        return (<li key={face.image_id} className="facelist-li">
                            <div className="facelist-item" onClick={() => onSelectFace(face)}>
                                <img src={checkUrl(face.url)} alt={face.id} />
                                <div className="facelist-trash" onClick={() => onDeleteFace(face)}>
                                    <FontAwesomeIcon icon={faTrash} />
                                </div>
                            </div>
                        </li>)
                    })}
                </ul>
            )
            }
        </section>
    );
}
